// @ts-nocheck
import { isValid as checkCpf } from '@fnando/cpf';
import { replaceAllNotDigitsTextCursor } from '../replaceWithCursorPosition';

export class MaskCpf {
  public insertIconValidate = true;

  public maxLength = 11;

  constructor(_view: any, public assets: any) {}

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    const { newValue, newCursorPosition } = replaceAllNotDigitsTextCursor(value, cursorPosition);

    if (newValue.length > this.maxLength) {
      return {
        newValue: newValue.substr(0, this.maxLength),
        newCursorPosition: newCursorPosition >= this.maxLength ? this.maxLength : newCursorPosition,
      };
    }

    return { newValue, newCursorPosition };
  }

  public setMask(
    value: string | number,
    cursorPosition
  ): { formatedValue; formatedCursorPosition } {
    try {
      const param = typeof value === 'number' ? String(value) : value;
      if (param.length <= 3) {
        return { formatedValue: param, formatedCursorPosition: cursorPosition };
      } else if (param.length <= 6) {
        const formatedValue = param.replace(/^(\d{3})(\d{1,3})$/, '$1.$2');
        const formatedCursorPosition = cursorPosition < 3 ? cursorPosition : cursorPosition + 1;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (param.length <= 9) {
        const formatedValue = param.replace(/^(\d{3})(\d{3})(\d{1,3})/, '$1.$2.$3');

        let formatedCursorPosition = cursorPosition;
        if (cursorPosition >= 3) formatedCursorPosition++;
        if (cursorPosition >= 6) formatedCursorPosition++;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else {
        const formatedValue = param.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');

        let formatedCursorPosition = cursorPosition;
        if (cursorPosition >= 3) formatedCursorPosition++;
        if (cursorPosition >= 6) formatedCursorPosition++;
        if (cursorPosition >= 9) formatedCursorPosition++;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      }
    } catch (err) {
      console.error('Error: ', err);
      return { formatedValue: value, formatedCursorPosition: cursorPosition };
    }
  }

  public validate(value) {
    return checkCpf(value);
  }

  public getMaskErrors() {
    return [this.assets.labels.feedbacks.masks['CPF']];
  }
}
